import { ProviderTimeslotsService } from '@App/services/api/ProviderTimeslots';
import { AvailableTimeslots } from '@App/services/api/ProviderTimeslots/types/AvailableTimeslots';
import { InsuranceType } from '@Framework/constants/InsuranceType';
import { createStore } from '@Framework/createStore';
import { StateCreator } from 'zustand';

export type VideoConsultationStore = {
  insuranceType?: InsuranceType;
  availableTimeslots?: AvailableTimeslots;
  setInsuranceType: (p: InsuranceType) => void;
  loadAvailableTimeslots: (date: Date) => Promise<void>;
};

const videoConsultationStore: StateCreator<VideoConsultationStore> = set => ({
  setInsuranceType: (insuranceType: InsuranceType) => set(() => ({ insuranceType })),
  loadAvailableTimeslots: async (date: Date) => {
    // TODO @Bencun: a very simplified version, this should be expanded to support timeslots info per provider
    const timeslots = await ProviderTimeslotsService.getAvailableTimeslots(date);
    set(() => ({ availableTimeslots: timeslots }));
  }
});

export const useVideoConsultationStore = createStore(videoConsultationStore, 'VideoConsultationStore');
